<script setup lang="ts">
import LanguagesModal from '@/components/Modal/LanguagesModal.vue';
import ModalInMiddle from '@/components/Modal/ModalInMiddle.vue';
import _service from '@/service';
import { useAccountStore } from '@/stores/account';
import { numFormatThousandths,handleTime, filterNumberValue } from '@/utils';
import { transact } from '@/utils/transact';
import { closeToast, showToast } from 'vant';
import { computed } from 'vue';
import { watch } from 'vue';
import { onMounted } from 'vue';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
const showLocaleModal = ref<boolean>(false)
const showStakeModal = ref<boolean>(false)
const showRedeemModal = ref<boolean>(false)
const stakeNumber = ref<number| null>(null)
const redeemNumber = ref<number| null>(null)
const museBalance = ref<number>(0)
const redeemTime = ref<string>('')
const stakeBalance = ref<number>(0)
const accountStore = useAccountStore()
const boosterLink = import.meta.env.VITE_MUSE_BOOSTER_LINK
const {t} = useI18n()

const stakeFn = async () => {
  try {
    console.log(stakeNumber.value,'stakeNumber.value');
    
    const actions: any = [];
    const _data = {
      account: import.meta.env.VITE_APP_MUSE_NAME,
      name: "transfer",
      data: {
        from:accountStore.getUserInfo.name,
        to:import.meta.env.VITE_APP_STAKE_NAME,
        quantity:`${Number(stakeNumber.value)?.toFixed(8)} MUSE`,
        memo: ""
      },
    };
    actions.push(_data);
    if (import.meta.env.VITE_APP_BEAT_NAME) {
      const _beatData = {
        account: import.meta.env.VITE_APP_BEAT_NAME,
        name: "refreshvotes",
        data: {
          owner:accountName.value
        },
      }
      actions.push(_beatData);
    }
    if (import.meta.env.VITE_APP_AUDITION_NAME) {
      const _starauditionData = {
        account: import.meta.env.VITE_APP_AUDITION_NAME,
        name: "refreshvotes",
        data: {
          owner:accountName.value
        },
      }
      actions.push(_starauditionData);
    }
    console.log(actions, "actions---");
    const res = await transact(actions);
    console.log(res.transaction_id, "res--transaction_id");
    
    showToast(t('Staked'))
    setTimeout(async() => {
      getMyStake()
      getMuseBalance()
    }, 1500);
    stakeNumber.value = null
    showStakeModal.value = false
  } catch (error) {
    console.log(error);
    closeToast()
    stakeNumber.value = null
    showStakeModal.value = false
  }
}

const getMyStake = async() => {
  const {rows}:any = await _service.getUserStake(accountName.value)
 if (rows.length && rows[0].tokens_stake.length) {
  const stakeItem = rows[0].tokens_stake.filter((item:any)=>{
    return item.key.sym === "8,MUSE" &&  item.key.contract === import.meta.env.VITE_APP_MUSE_NAME
  })[0]
  const {balance,redeemable_at} = stakeItem?.value
  const _stakeBalance = balance.split(' ')[0] || 0
  redeemTime.value = handleTime(redeemable_at)
  stakeBalance.value = +_stakeBalance
 }else{
  stakeBalance.value = 0
 }
  
}
const redeemFn = async() => {
  try {
    const actions: any = [];
    const _data = {
      account:import.meta.env.VITE_APP_STAKE_NAME,
      name:'unstaketoken',
      data:{
        account: accountName.value,
        tokens:[{
          quantity:`${Number(redeemNumber.value)?.toFixed(8)} MUSE`,
          contract:import.meta.env.VITE_APP_MUSE_NAME
        }]
      }
    };
    actions.push(_data);
    console.log(actions, "actions---");
    const res = await transact(actions);
    // console.log(res.transaction_id, "res--transaction_id");
    
    showToast(t('Redeem'))
    setTimeout(async() => {
      getMyStake()
      getMuseBalance()
    }, 1500);
    redeemNumber.value = null
    showRedeemModal.value = false
  } catch (error) {
    console.log(error);
    closeToast()
    redeemNumber.value = null
    showRedeemModal.value = false
  }
}

onMounted(()=>{
  setTimeout(() => {
    accountStore.connectWallet
  }, 1500);
})

const accountName = computed(() => {
  return accountStore.getUserInfo.name;
});

const getMuseBalance = async() => {
  const _balance:any = await _service.getBalanceByUser({
    code:import.meta.env.VITE_APP_MUSE_NAME,
    account: accountName.value,
    symbol:'MUSE',
  })
  museBalance.value = _balance.length ? _balance[0].split(" ")[0] : 0;
}

watch(()=>accountName.value,(val)=>{
  getMuseBalance()
  getMyStake()
})


watch(()=>showRedeemModal.value,(val)=>{
  getMyStake()
})



</script>

<template>
  <div class="muse-layout">
    <div class="header flex-row-between-center">
      <i class="logo"></i>
      <div class="right flex-row-start-center">
        <div class="wallet flex-row-start-center">
          <i class="wallet-icon"></i> <span class="wallet-address">{{accountName}}</span>
        </div>
        <div class="locale" @click="showLocaleModal = true">
          <i class="locale-icon"></i>
        </div>
      </div>
    </div>
    <div class="banner"></div>
    <div class="stake-bar-wrapper media-375">
      <div class="stake-bar">
        <div class="stake-bar-header">
          <div class="my-stake flex-row-between-center">
            <span>{{t('My Stake')}}</span>
            <span>{{t('Redeemable Time')}} <span class="time number-font">{{redeemTime}}</span></span>
          </div>
          <div class="token-number number-font flex-row-start-center">
            {{numFormatThousandths(stakeBalance)}}
            <i class="token-icon"></i>
          </div>
          <div class="btns-group">
            <div class="btn redeem" :class="{'disabled':!(stakeBalance > 0)}" @click="showRedeemModal = true">{{t('Redeem')}}</div>
            <div class="btn stake"  @click="showStakeModal = true">{{t('Stake')}}</div>
          </div>
        </div>
        <div class="stake-bar-footer flex-col-start-center">
          {{t('Staking MUSE can increase the voting power for activities on the StarNest platform, allowing you to vote for your favorite participants.')}}
          <a :href="boosterLink" class="tip flex-row-start-center">{{t('How to Obtain MUSE')}}？ <i class="right-icon"></i></a>
        </div>
      </div>
    </div>
    <div class="rules flex-col-start-start media-375">
      <div class="title">{{t('Activity Rules')}}</div>
      <div class="ct">
        {{t('Rule1')}}<br/>
        {{t('Rule2')}}<br/>
        {{t('Rule3')}}<br/>
        {{t('Rule4')}}
      </div>
    </div>
    <LanguagesModal v-model:isShow="showLocaleModal"></LanguagesModal>
    <ModalInMiddle v-model:isShow="showStakeModal" :title="t('Stake')">
      <div class="stake-modal common-modal">
        <div class="row-form">
          <div class="row-name">{{t('Stake Amount')}}</div>
          <div class="row-inputer flex-row-start-center">
            <input type="number" :placeholder="t('Please Enter Amount')" v-model="stakeNumber" @input="(event:any)=>{
              if (+event.target.value > +museBalance) {
                stakeNumber = +museBalance
              }else{
                stakeNumber = filterNumberValue(event.target.value,8)
              }
            }"> <span class="token number-font">MUSE</span>
          </div>
          <div class="extra flex-row-between-center"> <span>{{t('Balance')}}: <span class="number-font">{{numFormatThousandths(museBalance)}} MUSE</span></span> <span @click="stakeNumber = +museBalance">{{t('All')}}</span></div>
        </div>
        <div class="btn-group flex-col-center-center">
          <div class="confirm-btn flex-row-center-center" :class="{'disabled':!(stakeNumber && stakeNumber > 0 && museBalance > 0)}"  @click="stakeFn">{{t('Confirm')}}</div>
          <div class="cancel-btn flex-row-center-center" @click="showStakeModal = false">{{t('Cancel')}}</div>
        </div>
      </div>
    </ModalInMiddle>
    <ModalInMiddle v-model:isShow="showRedeemModal" :title="t('Redeem')">
      <div class="redeem-modal common-modal">
        <div class="row-form">
          <div class="row-name">{{t('Redeem Amount')}}</div>
          <div class="row-inputer flex-row-start-center">
            <input type="number" :placeholder="t('Please Enter Amount')" v-model="redeemNumber" @input="(event:any)=>{
              if (event.target.value > stakeBalance) {
                redeemNumber = stakeBalance
              }else{
                redeemNumber = filterNumberValue(event.target.value,8)
              }
            }" :class="{'disabled':!(redeemNumber && redeemNumber > 0)}"> <span class="token number-font">MUSE</span>
          </div>
          <div class="extra flex-row-between-center"> <span>{{t('Redeemable Time')}} <span class="number-font">{{redeemTime || '-'}}</span></span><span  @click="redeemNumber = stakeBalance">{{t('All')}}</span></div>
        </div>
        <div class="btn-group flex-col-center-center">
          <div class="confirm-btn flex-row-center-center" :class="{'disabled':new Date(redeemTime).getTime() > new Date().getTime()}" @click="redeemFn">{{t('Confirm')}}</div>
          <div class="cancel-btn flex-row-center-center" @click="showRedeemModal = false">{{t('Cancel')}}</div>
        </div>
      </div>
    </ModalInMiddle>
  </div>
</template>

<style lang="scss" scoped>
.muse-layout{
  height: 100%;
  min-height: 100vh;
  background: #070B14;
  padding-bottom: 100px;
  .header{
    width: 100%;
    height: 54px;
    padding: 0 12px;
    .logo{
      width: 24px;
      height: 24px;
      background: url(../../assets/muse/token-icon.svg);
      background-size: contain;
      background-repeat: no-repeat;
    }
    .right{
      gap: 6px;
      .wallet{
        padding: 2px 6px;
        gap: 4px;
        color: #FFF;
        font-size: 12px;
        border-radius: 10px;
        border: 1px solid #FFF;
        .wallet-icon{
          width: 24px;
          height: 24px;
          background: url(../../assets/muse/wallet.svg);
          background-size: contain;
          background-repeat: no-repeat;
        }
        .wallet-address{
          min-width: 40px;
          text-align: center;
        }
      }
      .locale{
        .locale-icon{
          display: inline-block;
          width: 24px;
          height: 24px;
          background: url(../../assets/muse/locale.svg);
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
    }
  }
  .banner{
    width: 100%;
    height: 250px;
    background: url(../../assets/muse/muse-banner.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    @media screen and (min-width: 768px) {
      width: 375px;
      margin: 0 auto;
    }
  }
  .stake-bar-wrapper{
    padding: 0 16px;
    margin-top: -20px;
    .stake-bar{
      width: 100%;
      display: flex;
      padding: 20px 16px;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      border-radius: 12px;
      border: 1px solid rgba(255, 255, 255, 0.80);
      background-color: rgba(255, 255, 255, 0.10);
      backdrop-filter: blur(5px);
      .stake-bar-header{
        width: 100%;
        .my-stake{
          width: 100%;
          color: #9C9CAA;
          font-size: 12px;
          .time{
            color: #fff;
            margin-left: 4px;
          }
        }
        .token-number{
          font-size: 21px;
          color: #fff;
          font-weight: 700;
          gap: 4px;
          margin-top: 8px;
          margin-bottom: 24px;
          .token-icon{
            width: 24px;
            height: 24px;
            background: url(../../assets/muse/token-icon.svg);
            background-size: contain;
            background-repeat: no-repeat;
          }
        }
        .btns-group{
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 12px;
          .btn{
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 12px;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            &.redeem{
              width: 96px;
              color: #E43F5A;
              border: 1px solid #E43F5A;
              &.disabled{
                opacity: 0.3;
                pointer-events: none;
              }
            }
            &.stake{
              flex: 1;
              color: #070B14;
              background: linear-gradient(111deg, #FFF853 4.98%, #6EEF94 56.05%, #2AD8CD 95.37%);
            }
          }
        }
      }
      .stake-bar-footer{
        border-top: 1px solid #545769;
        color: #fff;
        font-size: 14px;
        padding-top: 16px;
        line-height: 1.2;
        gap: 12px;
        .tip{
          color:  #6EFA97;
          font-size: 12px;
          .right-icon{
            display: inline-block;
            width: 16px;
            height: 16px;
            background: url(../../assets/muse/right-icon.svg);
            background-size: contain;
            background-repeat: no-repeat;
          }
        }
      }
    }
  }
  .rules{
    padding: 0 16px;
    margin-top: 28px;
    gap: 8px;
    .title{
      font-size: 14px;
      color: #fff;
      font-weight: 600;
    }
    .ct{
      color: #9C9CAA;
      font-size: 12px;
      line-height: 1.5;
    }
  }
}


.common-modal{

  .row-form{

    .row-name{
      font-size:12px;
      color: #9C9CAA;
    }
    .row-inputer{
      width: 100%;
      height: 50px;
      margin-top: 6px;
      border-radius: 9px;
      background: #1F212D;
      padding: 0 12px;
      margin-bottom: 6px;
      input{
        flex: 1;
        font-weight: 700;
        &::placeholder{
          color: #565662;
        }
      }
      .token{
        font-size: 14px;
        color: #fff;
        font-weight: 700;
      }
    }
    .extra{
      font-size: 12px;
      color: #9C9CAA;
      .number-font{
        color: #fff;
      }
    }
  }
  .btn-group {
    margin-top: 24px;
    .confirm-btn {
      width: 100%;
      height: 48px;
      border-radius: 12px;
      background: linear-gradient(
        111deg,
        #fff853 4.98%,
        #6eef94 56.05%,
        #2ad8cd 95.37%
      );
      color: #070B14;
      font-size: 16px;
      cursor: pointer;
      &.disabled{
        opacity: 0.3;
        pointer-events: none;
      }
    }
    .cancel-btn{
      width: 100%;
      height: 48px;
      font-size: 16px;
      cursor: pointer;
      color: #999;
    }
  }
}
</style>
